<template>
<v-app>
<v-content v-bind:class="[activeClass]">
<router-view></router-view>
</v-content>
</v-app>
</template>

<script>
  export default {
    data () {
      return {
		activeClass: 'home'
      }
    },
    

  }
</script>
